import { render, staticRenderFns } from "./Livestream.vue?vue&type=template&id=2016d09c&scoped=true"
import script from "./Livestream.vue?vue&type=script&lang=js"
export * from "./Livestream.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2016d09c",
  null
  
)

export default component.exports